import {
  LIST_SHIFT_REQUEST,
  LIST_SHIFT_SUCCESS,
  LIST_SHIFT_FAIL,
  LIST_SHIFT_SUMMARY_REQUEST,
  LIST_SHIFT_SUMMARY_SUCCESS,
  LIST_SHIFT_SUMMARY_FAIL,
  CREATE_SHIFT_REQUEST,
  CREATE_SHIFT_SUCCESS,
  CREATE_SHIFT_FAIL,
  DETAIL_SHIFT_REQUEST,
  DETAIL_SHIFT_SUCCESS,
  DETAIL_SHIFT_FAIL,
  UPDATE_SHIFT_REQUEST,
  UPDATE_SHIFT_SUCCESS,
  UPDATE_SHIFT_FAIL,
  DELETE_SHIFT_REQUEST,
  DELETE_SHIFT_SUCCESS,
  DELETE_SHIFT_FAIL,
  RESET_SHIFT
} from '../../constants/shift'

const initialState = {
  loading: false,
  shifts: [],
  shiftsSummary: [],
  shift: {},
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const shiftsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_SHIFT_REQUEST:
      return { ...state, loading: true }
    case LIST_SHIFT_SUCCESS:
      return {
        ...state,
        loading: false,
        shifts: action.payload,
        pageable: action.pageable
      }
    case LIST_SHIFT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        shifts: action?.dummy
      }
    case LIST_SHIFT_SUMMARY_REQUEST:
      return { ...state, loading: true }
    case LIST_SHIFT_SUMMARY_SUCCESS:
      return { ...state, loading: false, shiftsSummary: action.payload, error: null }
    case LIST_SHIFT_SUMMARY_FAIL:
      return { ...state, loading: false, error: action.payload }
    case CREATE_SHIFT_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_SHIFT_SUCCESS:
      return { ...state, loadingCreate: false, error: null }
    case CREATE_SHIFT_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DETAIL_SHIFT_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_SHIFT_SUCCESS:
      return { ...state, loadingDetail: false, error: null, shift: action.payload }
    case DETAIL_SHIFT_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }
    case UPDATE_SHIFT_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_SHIFT_SUCCESS:
      return { ...state, loadingUpdate: false, error: null }
    case UPDATE_SHIFT_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DELETE_SHIFT_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_SHIFT_SUCCESS:
      const shiftIdDelete = action.payload
      const shiftsDelete = [...state.shifts]

      const indexDelete = shiftsDelete.findIndex(
        (shift) => shift.id === shiftIdDelete
      )
      shiftsDelete.splice(indexDelete, 1)
      return { ...state, loadingDelete: false, shifts: shiftsDelete, eeror: null }
    case DELETE_SHIFT_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case RESET_SHIFT:
      return { ...state, loading: false, error: null }
    default:
      return state
  }
}

export default shiftsReducer
